::ng-deep mail-template-content{display:flex;flex-grow:1;justify-content:center;margin-bottom:10px}
/*# sourceMappingURL=mail-template-content.component-G67HFOKS.css.map */
